import { Injectable } from '@angular/core';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

@Injectable()
export class MetricsService {
  constructor(private apolloService: ApolloService) {}

  public publishTimeSeriesMetricEvent(metricName: string): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.PUBLISH_TIME_SERIES_METRIC_EVENT_MUTATION,
      { metricName },
      (_result) => {}
    );
  }
}
